export const getServiceBanner = ({ serviceBanner }) => serviceBanner;
